export enum HbsSearchParamKey {
  VISIT_ID = 'visitId',
  PATIENT_ID = 'patientId',
  SAMPLE_ID = 'sampleId',
  SAMPLE_CODE = 'sampleCode',
  SAMPLE_CODES = 'sampleCodes',
  KIT_CODE = 'kitCode',
  PARENT_SAMPLE_ID = 'parentSampleId',
}
